document.addEventListener("DOMContentLoaded", () => {
    const activeClasses = {
        button: "main-faq__navigation-button--active",
        faqItem: "faq-list__item--active"
    };

    const navigationButtons = document.querySelectorAll(".main-faq__navigation-button");
    const faqCheckboxes = document.querySelectorAll(".main-faq__content input");

    navigationButtons.forEach((button, index, buttonsArray) => {
        button.addEventListener("click", () => {
            handleNavigationClick(button, index, buttonsArray);
        });
    });

    faqCheckboxes.forEach((checkbox, _index, checkboxsArray) => {
        checkbox.addEventListener("change", () => {
            handleCheckboxChange(checkbox, checkboxsArray);
        });
    });

    function handleNavigationClick(button, index, buttonsArray) {
        const { typeTab } = button.dataset;
        const faqContainer = button.closest(".main-faq");
        const allFaqItems = faqContainer.querySelectorAll(".faq-list__item");

        updateActiveButton(buttonsArray, index);
        updateActiveFaqItems(allFaqItems, typeTab);
    }

    function handleCheckboxChange(checkbox, inputsArray) {
        if (checkbox.checked) {
            inputsArray.forEach(input => (input.checked = false));
            checkbox.checked = true;
        } else {
            checkbox.checked = false;
        }
    }

    function updateActiveButton(buttonsArray, activeIndex) {
        buttonsArray.forEach(button =>
            button.classList.remove(activeClasses.button)
        );
        buttonsArray[activeIndex].classList.add(activeClasses.button);
    }

    function updateActiveFaqItems(faqItems, typeTab) {
        const activeFaqItems = [...faqItems].filter(
            item => item.dataset.typeFaq === typeTab
        );

        faqItems.forEach(item => item.classList.remove(activeClasses.faqItem));
        activeFaqItems.forEach(item => item.classList.add(activeClasses.faqItem));
    }


});
